function asContactArray(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string" && value.trim()) return [value];
  return [];
}

export function hasContacts(results) {
  if (!results) {
    return false;
  }

  const emails = asContactArray(results.ListEmailsWithMask?.Email).length > 0;
  const phones = asContactArray(results.ListPhonesWithMask?.PhoneNumber).length > 0;

  return emails || phones;
}

export const CONTACTS_NOT_FOUND_MESSAGE =
  'Não foi possível localizar contatos para este documento. Verifique os dados informados ou entre em contato pelo WhatsApp.';
